
const constracted = {
  state: {

  },
  mutations: {
    TOGGLE_SIDEBAR: state => {

    },
  },
  actions: {
    ToggleSideBar: ({commit}) => {
      commit('TOGGLE_SIDEBAR')
    },
  },
  getters: {
  }
}

export default constracted



// WEBPACK FOOTER //
// ./src/store/modules/contracted.js